<div class="single-courses-item mb-30">
    <div class="courses-image">
        <a (click)="onRouteToDetail(course.id)" class="d-block">
            <img src="{{course.image.fileUrl}}" alt="image"></a>
    </div>
    <div class="courses-content">
        <div class="d-flex justify-content-between align-items-center">
            <div class="course-author d-flex align-items-center">


                <img *ngIf="course.teacher.avatarUrl !== '' else elseBlock" src="{{course.teacher.avatarUrl}}"
                    class="shadow" alt="image">
                <ng-template #elseBlock>
                    <img src="assets/img/teacher-placeholder.png">
                </ng-template>
                <span>{{course.teacher.name}}</span>
            </div>

            <!-- <div class="courses-rating">
                <div class="review-stars-rated">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star-half'></i>
                </div>

                <div class="rating-total">
                    4.5 (2)
                </div>
            </div> -->
        </div>

        <h3><a (click)="onRouteToDetail(course.id)" class="d-inline-block">{{course.name}}</a></h3>
        <!-- <p class="short-desc">{{course.descriptionEn}}</p> -->
    </div>

    <div class="courses-box-footer" *ngIf="!hidePrice">
        <ul>
            <li class="students-number">
                <i class='bx bx-user'></i> {{course.studentsCount}} students
            </li>

            <!-- <li class="courses-lesson">
                <i class='bx bx-book-open'></i> {{course.lessonsCount}} lessons
            </li> -->

            <li class="courses-price text-right">
                <span *ngIf="course.checkDiscountPrice()">${{course.price}}</span>
                <label class="show-price">${{course.getShowPrice()}}</label>
            </li>
        </ul>
    </div>
</div>